import { useState } from 'react';

/**
 * 在组件创建时执行，并且在组件的生命周期中不会再次执行
 *
 * 暂用 useState 方案，后续有更优的方案可以进行替换
 *
 * @param fn 需要执行的方法
 */
const useComponentConstructor = (fn: () => void) => {
    useState(() => {
        fn();
    });
};

export default useComponentConstructor;
